export enum AttachmentType {
  PRAKTIKUMSNACHWEIS = "PRAKTIKUMSNACHWEIS",
  SONDERFALLNACHWEIS = "SONDERFALLNACHWEIS",
  BEZUGSNACHWEIS = "BEZUGSNACHWEIS",
  BESTAETIGUNGSBESCHEID = "BESTAETIGUNGSBESCHEID",
  ABLEHNUNGSBESCHEID = "ABLEHNUNGSBESCHEID",
  ANHOERUNGSBESCHEID = "ANHOERUNGSBESCHEID",
  OTHER = "OTHER"

}

export function getSelectableAttachmentTypes(): AttachmentType[] {
  return Object.values(AttachmentType).filter((type) => {
    return type !== AttachmentType.BESTAETIGUNGSBESCHEID
      && type !== AttachmentType.ABLEHNUNGSBESCHEID
      && type !== AttachmentType.ANHOERUNGSBESCHEID;
  });
}

